export const ACTIVITY_GRAHQL_TYPES = {
	WORK_ASSIGNMENT: 'CrewMemberWorkAssignmentActivityItem',
	ABSENCE: 'CrewMemberAbsenceActivityItem',
	BREAK: 'CrewMemberBreakActivityItem',
	MANUAL_RECONCILIATION: 'CrewMemberManualReconciliation',
	TAIL: 'ShiftTail',
};

// TODO: HANDLE WHEN CODE IS PROVIDED
export const UNAVAILABILITY_GRAHQL_REASONS = {
	RRO_TIMEOFF: 'regularOperatorTimeOff',
};

export const ACTIVITY_RENDER_TYPES = {
	absence: 'absence',
	assignment: 'assignment',
	planned: 'planned',
	rest: 'rest',
	idle: 'idle',
	traveling: 'traveling',
	protection: 'protection',
	deadhead: 'deadhead',
	rroTimeOffAvailabilityEnabled: 'rroTimeOffAvailabilityEnabled',
	rroTimeOffAvailabilityDisabled: 'rroTimeOffAvailabilityDisabled',
	signOn: 'signOn',
	signOff: 'signOff',
	fuelling: 'fuelling',
	cleaning: 'cleaning',
	garaging: 'garaging',
	lapseTime: 'lapseTime',
	extra: 'extra',
};

export const ACTIVITY_LAYOUT_VARIANTS = {
	activity: 'activity',
	rest: 'rest',
	idle: 'idle',
	extraActivity: 'extraActivity',
	absence: 'absence',
	rroTimeOffAvailabilityEnabled: 'rroTimeOffAvailabilityEnabled',
	rroTimeOffAvailabilityDisabled: 'rroTimeOffAvailabilityDisabled',
	shiftTail: 'shiftTail',
};

export const AUXILIARY_WA_STATUS = {
	created: 'created',
	pending: 'pending',
	confirmed: 'confirmed',
	rejected: 'rejected',
	actual: 'actual',
};
export const EMPLOYMENT_CHANGE = 'employmentChange';
export const UPDATE_CREW_LOCATION = 'updateCrewLocation';
export const RRO_TIME_OFF_ABSENCE_REASON_NAME = 'Regular operator time off';
